export default __webpack_public_path__ + "static/media/lynda.f850152d.png";